import { Component, OnInit, Input } from '@angular/core';
import { FileUploadService } from '../../api/services/file-upload.service';
import { FileUploaded } from '../../api/models/file-uploaded';

@Component({
  selector: 'app-file-description',
  templateUrl: './file-description.component.html',
  styleUrls: ['./file-description.component.scss']
})
export class FileDescriptionComponent implements OnInit {

  @Input() fileId: string;
  @Input() onlySize: boolean;
  @Input() onlyName: boolean;

  file: FileUploaded;

  constructor(private fileService: FileUploadService) { }

  humanReadableFileSize(size: number) {
    const i = Math.floor( Math.log(size) / Math.log(1024) );
    return `${(size / Math.pow(1024, i) ).toFixed(2)} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
  }

  ngOnInit() {
    this.fileService.get(this.fileId).subscribe(file => {
      this.file = file;
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/file-description/file-description.component.ts